import React, { useContext, useEffect, useState } from "react";
import DashSidebar from "../../components/dashboard/DashSidebar";
import axios from "../../helper/axios";
import { AuthContext } from "../../context/AuthContext";

const Tax = () => {
  const [isTaxLoading, setIsTaxLoading] = useState(true);
  const [tax, setTax] = useState([]);

  const [editTaxData, setEditTaxData] = useState({
    id: "",
    country_id: "",
    tax1: "",
    tax2: "",
    tax3: "",
    othercharges1: "",
    othercharges2: "",
    othercharges3: "",
  });

  const [newTaxData, setNewTaxData] = useState({
    country_id: "",
    tax1: "",
    tax2: "",
    tax3: "",
    othercharges1: "",
    othercharges2: "",
    othercharges3: "",
  });

  const { token } = useContext(AuthContext);

  const getActiveClass = (route) => {
    return location.pathname === route ? "active" : "";
  };

  const editTax = (taxItem) => {
    setEditTaxData(taxItem);
  };

  const handleNewTaxDataChange = (event) => {
    const { name, value } = event.target;
    setNewTaxData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditTaxDataChange = (event) => {
    const { name, value } = event.target;
    setEditTaxData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    fetchTaxData();
  }, []);

  const fetchTaxData = async () => {
    try {
      const response = await axios.get("/taxmaster_read", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const taxData = response.data.data;
      setTax(taxData);
      //   console.log(taxData, "taxData");
      setIsTaxLoading(false);
    } catch (error) {
      console.error("Error fetching tax data:", error);
    }
  };

  const createTax = async () => {
    try {
      await axios.post("/taxmaster_insert", newTaxData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setNewTaxData({
        country_id: "",
        tax1: "",
        tax2: "",
        tax3: "",
        otherCharges1: "",
        otherCharges2: "",
        otherCharges3: "",
      });
      alert("Tax Created Successfully");
      fetchTaxData();
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (error.response.data.message.includes("Foreign key error")) {
          alert("Country ID Already Inserted!!");
        } else {
          alert(error.response.data.message);
        }
      }
      console.error("Error creating tax data:", error.message);
    }
  };

  const updateTax = async () => {
    try {
      await axios.put(`/taxmaster_update/${editTaxData.id}`, editTaxData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setEditTaxData({
        id: "",
        country_id: "",
        tax1: "",
        tax2: "",
        tax3: "",
        othercharges1: "",
        othercharges2: "",
        othercharges3: "",
      });

      fetchTaxData();
      alert("Tax Updated Successfully");
    } catch (error) {
      console.error("Error updating tax data:", error);
    }
  };

  const deleteTax = async (id) => {
    if (window.confirm("Are you sure you want to Delete This Tax Data ?")) {
      try {
        await axios.delete(`/taxmaster_delete/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        fetchTaxData();
        alert("Tax Deleted Successfully");
      } catch (error) {
        console.error("Error deleting tax data:", error);
      }
    }
  };

  const clearFormData = () => {
    setNewTaxData({
      country_id: "",
      tax1: "",
      tax2: "",
      tax3: "",
      othercharges1: "",
      othercharges2: "",
      othercharges3: "",
    });
  };

  return (
    <>
      <section className="mt-3">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-2">
              <DashSidebar activeClass={getActiveClass("/tax")} />
            </div>
            <div className="col-sm-10 light-border p-4">
              <div className="control-btn-nav pb-3 row">
                <div className="col-sm-10">
                  <h3>
                    <b>Taxation</b>
                  </h3>
                </div>
                <div className="col-sm-2">
                  <button
                    className="btn btn__primary"
                    data-bs-toggle="modal"
                    data-bs-target="#addTaxModal"
                  >
                    Create TAX
                  </button>
                </div>
              </div>

              {isTaxLoading ? (
                <>
                  <p>Loading Data...</p>
                </>
              ) : (
                <>
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">ID</th>
                        <th scope="col">Country ID</th>
                        <th scope="col">Country Name</th>
                        <th scope="col">Tax 1</th>
                        <th scope="col">Tax 2</th>
                        <th scope="col">Tax 3</th>
                        <th scope="col">Other Charges 1</th>
                        <th scope="col">Other Charges 2</th>
                        <th scope="col">Other Charges 3</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tax.map((taxItem, index) => (
                        <React.Fragment key={taxItem.id}>
                          <tr key={taxItem.id}>
                            <th scope="row">{index + 1}</th>
                            <td>{taxItem.id}</td>
                            <td>{taxItem.country_id}</td>
                            <td>{taxItem.country_name}</td>
                            <td>{taxItem.tax1}</td>
                            <td>{taxItem.tax2}</td>
                            <td>{taxItem.tax3}</td>
                            <td>{taxItem.othercharges1}</td>
                            <td>{taxItem.othercharges2}</td>
                            <td>{taxItem.othercharges3}</td>
                            <td>
                              <div className="d-flex">
                                <span
                                  className="action-icon"
                                  data-bs-toggle="modal"
                                  data-bs-target={`#editTaxModal${taxItem.id}`}
                                  onClick={() => {
                                    editTax(taxItem);
                                  }}
                                >
                                  <i className="fa-solid fa-pen-to-square"></i>
                                </span>

                                <span
                                  className="action-icon"
                                  onClick={() => deleteTax(taxItem.id)}
                                >
                                  <i className="fa-solid fa-trash"></i>
                                </span>
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </>
              )}

              <div
                className="modal fade"
                id="addTaxModal"
                tabIndex="-1"
                role="dialog"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Create Taxation</h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body">
                      <form>
                        <div className="my-2">
                          <label className="form-label">Country ID</label>
                          <input
                            type="text"
                            name="country_id"
                            className="form-control"
                            value={newTaxData.country_id}
                            required
                            onChange={handleNewTaxDataChange}
                          />
                        </div>

                        <div className="row">
                          <div className="col-6">
                            <div className="my-2">
                              <label className="form-label">Tax 1</label>
                              <input
                                type="text"
                                name="tax1"
                                className="form-control"
                                value={newTaxData.tax1}
                                onChange={handleNewTaxDataChange}
                              />
                            </div>
                            <div className="my-2">
                              <label className="form-label">Tax 2</label>
                              <input
                                type="text"
                                name="tax2"
                                className="form-control"
                                value={newTaxData.tax2}
                                onChange={handleNewTaxDataChange}
                              />
                            </div>
                            <div className="my-2">
                              <label className="form-label">Tax 3</label>
                              <input
                                type="text"
                                name="tax3"
                                className="form-control"
                                value={newTaxData.tax3}
                                onChange={handleNewTaxDataChange}
                              />
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="my-2">
                              <label className="form-label">
                                Other Charges 1
                              </label>
                              <input
                                type="text"
                                name="othercharges1"
                                className="form-control"
                                value={newTaxData.othercharges1}
                                onChange={handleNewTaxDataChange}
                              />
                            </div>
                            <div className="my-2">
                              <label className="form-label">
                                Other Charges 2
                              </label>
                              <input
                                type="text"
                                name="othercharges2"
                                className="form-control"
                                value={newTaxData.othercharges2}
                                onChange={handleNewTaxDataChange}
                              />
                            </div>
                            <div className="my-2">
                              <label className="form-label">
                                Other Charges 3
                              </label>
                              <input
                                type="text"
                                name="othercharges3"
                                className="form-control"
                                value={newTaxData.othercharges3}
                                onChange={handleNewTaxDataChange}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn__secondary"
                            onClick={clearFormData}
                          >
                            Clear
                          </button>
                          <button
                            type="button"
                            onClick={createTax}
                            className="btn btn__primary"
                          >
                            Create Taxation
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              {editTaxData && (
                <>
                  <div
                    className="modal fade"
                    id={`editTaxModal${editTaxData.id}`}
                    tabIndex="-1"
                    role="dialog"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog" role="document">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Edit Taxation</h5>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div className="modal-body">
                          <form>
                            <div className="my-2">
                              <label className="form-label">Country ID</label>
                              <input
                                type="text"
                                name="country_id"
                                className="form-control"
                                value={editTaxData.country_id}
                                onChange={handleEditTaxDataChange}
                                disabled
                              />
                            </div>

                            <div className="row">
                              <div className="col-6">
                                <div className="my-2">
                                  <label className="form-label">Tax 1</label>
                                  <input
                                    type="text"
                                    name="tax1"
                                    className="form-control"
                                    value={editTaxData.tax1}
                                    onChange={handleEditTaxDataChange}
                                  />
                                </div>
                                <div className="my-2">
                                  <label className="form-label">Tax 2</label>
                                  <input
                                    type="text"
                                    name="tax2"
                                    className="form-control"
                                    value={editTaxData.tax2}
                                    onChange={handleEditTaxDataChange}
                                  />
                                </div>
                                <div className="my-2">
                                  <label className="form-label">Tax 3</label>
                                  <input
                                    type="text"
                                    name="tax3"
                                    className="form-control"
                                    value={editTaxData.tax3}
                                    onChange={handleEditTaxDataChange}
                                  />
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="my-2">
                                  <label className="form-label">
                                    Other Charges 1
                                  </label>
                                  <input
                                    type="text"
                                    name="othercharges1"
                                    className="form-control"
                                    value={editTaxData.othercharges1}
                                    onChange={handleEditTaxDataChange}
                                  />
                                </div>
                                <div className="my-2">
                                  <label className="form-label">
                                    Other Charges 2
                                  </label>
                                  <input
                                    type="text"
                                    name="othercharges2"
                                    className="form-control"
                                    value={editTaxData.othercharges2}
                                    onChange={handleEditTaxDataChange}
                                  />
                                </div>
                                <div className="my-2">
                                  <label className="form-label">
                                    Other Charges 3
                                  </label>
                                  <input
                                    type="text"
                                    name="othercharges3"
                                    className="form-control"
                                    value={editTaxData.othercharges3}
                                    onChange={handleEditTaxDataChange}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn__secondary"
                                data-bs-dismiss="modal"
                                onClick={() => setEditTaxData(null)}
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                className="btn btn__primary"
                                onClick={updateTax}
                                data-bs-dismiss="modal"
                              >
                                Update Taxation
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Tax;
